import React from 'react';
import PanelSection from 'components/v2/PanelSection';
import classnames from 'classnames';

export default function CardHeader({ title, className, children }) {
  return (
    <PanelSection className={classnames(className)}>
      <div className="flex items-center justify-between">
        <h3>{title}</h3>
        {children}
      </div>
    </PanelSection>
  );
}
